import {
  Button,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Box,
  Modal,
  ArrowBackIosNewOutlined as ArrowBackIosNewOutlinedIcon,
} from "../../../common/utils/mui-imports";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import HPRTextBox from "../../../components/common/HPRTextBox/HPRTextBox";
import { EnumTextBoxType } from "../../../components/common/HPRTextBox/HPRTextBox.enum";
import { SystemPageParametersType, SystemPageType } from "./SystemPage.types";
import { useAppDispatch, useAppSelector } from "../../../core/hooks";
import {
  deleteStandardSystem,
  getStandardSystemList,
  saveStandardSystem,
  updateStandardSystem,
} from "./SystemPage.action";
import HPRDataGrid from "../../../components/common/HPRDataGrid/HRPDataGrid";
import { PageModeType } from "../../../common/types/common.page.type";
import {
  PaginationDTO,
  SearchParameterDTO,
  SortDropDownDTO,
  StandardSystemDTO,
  StatusSummaryCountDTO,
} from "../../../common/types/common.dto.types";
import { PageRegistrationProperties } from "../../../core/reducers/pageRegistrationReducer.types";
import usePageRegistration from "../../../core/hooks/usePageRegistration";
import {
  EnumButtonModeType,
  EnumGridDataShowRowCount,
  EnumPageMode,
  EnumPageType,
  EnumSortTypes,
  EnumStandardSourceSortType,
  EnumStatus,
} from "../../../common/enums/common.enums";
import {
  setPageMode,
  setStandardSystem,
  setStandardSystemInitState,
  setStandardSystemSearchParameter,
  setSystemModalOpen,
} from "./SystemPage.reducer";
import {
  AddCircle,
  ArrowRight2,
  CardSlash,
  CloseCircle,
  Edit,
  SearchNormal1,
} from "iconsax-react";
import { useNavigate } from "react-router-dom";
import { StandardPageParametersType } from "../StandardPage/StandardPage.types";
import HPRSplitButton from "../../../components/common/HPRSplitButton/HPRSplitButton";
import { openPopup } from "../../../components/Popups/Popup.reducer";
import { PopupProps } from "../../../components/Popups/PopupProps.types";
import { EnumPopupType } from "../../../components/Popups/Popup.enum";
import SimpleReactValidator from "simple-react-validator";
import dayjs from "dayjs";
import {
  HPRDataGridToolbarProps,
  HPRGridColDef,
} from "../../../components/common/HPRDataGrid/HPRDataGrid.types";
import {
  EnumSystemFunctions,
  EnumSystemFunctionTypes,
} from "../../../core/reducers/functionRights.types";
import { CheckFunctionRights } from "../../../common/functions/common.functions";

const initialState = {
  PageMode: {
    PageMode: EnumPageMode.Default,
    IsDisable: true,
    IsShowAddBtn: true,
    IsShowEditBtn: false,
    IsShowDeleteBtn: false,
    IsShowCancelBtn: false,
    IsShowSaveBtn: false,
    IsShowUpdateBtn: false,
    IsShowCloseBtn: false,
  } as PageModeType,
  Data: {
    Data: [] as Array<StandardSystemDTO>,
    PageSize: EnumGridDataShowRowCount.GridDataShowRowCount_2,
    SelectedPage: 1,
    TotalRecordsCount: 0,
    StatusSummaryCount: {} as StatusSummaryCountDTO,
  } as PaginationDTO,
  StandaradSystem: {
    Id: 0,
    Name: "",
    StandardId: 0,
    Version: 1,
    Status: EnumStatus.Published,
  } as StandardSystemDTO,
  StandardSystemSearchParameter: {
    StandardSystemSearchParams: {
      Name: "",
      StandardId: 0,
    } as StandardSystemDTO,
    IsAdvanceSearch: false,
    SelectedPage: 1,
    GridPageSize: EnumGridDataShowRowCount.GridDataShowRowCount_2,
    // SortByNavigation: {
    //   Label: "Name",
    //   Value: EnumStandardSourceSortType.Name.toString(),
    //   SortType: EnumSortTypes.Ascending,
    // } as SortDropDownDTO, //commented for consistency
  } as SearchParameterDTO,
  SystemModalOpen: false,
  Validator: new SimpleReactValidator({
    messages: {
      default: "This field is required",
    },
  }),
  ShowErrorMsg: false,
  ButtonModeType: EnumButtonModeType.Save,
} as SystemPageType;

const SystemPage = (props: PageRegistrationProperties) => {
  usePageRegistration(props);
  // create state for StandardPageType with initialState values
  const [standardSystemPageState, setstandardSystemPageState] =
    useState(initialState);

  // pass parameters to page

  const location = useLocation();
  const parameter: SystemPageParametersType = location.state;

  // use for page navigation
  const navigate = useNavigate();

  const dataFetchedRef = useRef(false);

  const dispatch = useAppDispatch();
  const standardSystemState = useAppSelector(
    (state) => state.standardSystemReducer
  );
  const authState = useAppSelector((state) => state.authReducer);

  //open and close Modal
  const handleOpen = () => {
    dispatch(setSystemModalOpen(true));
  };
  const handleClose = () => {
    dispatch(setSystemModalOpen(false));
  };

  const checkSystemFunctionRight = (
    functionId: EnumSystemFunctions,
    functionTypeId: EnumSystemFunctionTypes
  ): boolean => {
    return CheckFunctionRights(
      authState.FunctionRights,
      EnumPageType.System,
      functionId,
      functionTypeId
    );
  };

  //=========================================================
  const columns: HPRGridColDef[] = [
    {
      field: "Id",
      headerName: "Id",
      hideColumn: true,
      hideable: false,
      filterable: false,
      flex: 0.5,
    },
    {
      field: "Name-1",
      headerName: "System",
      flex: 14,
      valueGetter: (params) => params.row?.Name,
      value: "",
    },
    {
      field: "ModifiedBy-3",
      headerName: "Last modified by",
      flex: 6,
      valueGetter: (params) => params.row?.ModifiedBy,
      value: "",
    },
    {
      field: "ModifiedDate-4",
      headerName: "Last modified date",
      flex: 6,
      valueGetter: (params) =>
        dayjs(params.row?.ModifiedDate).format("DD-MMM-YYYY HH:mm"),
      value: "",
    },
    {
      field: " ",
      flex: 1,
      hide: parameter?.StatusId === EnumStatus.Deactivated,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const onClick = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking

          dispatch(
            setStandardSystem({
              Id: params.row?.Id,
              Name: params.row?.Name,
              StandardId: parameter?.StandardId,
            } as StandardSystemDTO)
          );

          setstandardSystemPageState((values) => {
            return {
              ...values,
              StandaradSystem: {
                ...values.StandaradSystem,
                Name: params.row?.Name,
                Id: params.row?.Id,
              },
            };
          });
          onClickViewBtn();
        };

        return (
          <>
            {checkSystemFunctionRight(
              EnumSystemFunctions.SystemPage_View_System,
              EnumSystemFunctionTypes.ButtonAccess
            ) && (
              <Button
                className="standards-icon-forward align-right flex-valign-middle cursor-pointer grid-icon-btn"
                onClick={onClick}
              >
                <ArrowRight2 size="32" variant="Outline" />
              </Button>
            )}
          </>
        );
      },
    },
  ];

  //Page onload
  useEffect(() => {
    if (parameter?.StandardId > 0) {
      if (dataFetchedRef.current) return;
      dataFetchedRef.current = true;
      dispatch(
        setStandardSystemInitState({
          ...standardSystemState,
          StandaradSystem: {
            ...standardSystemState.StandaradSystem,
            StandardId: parameter.StandardId,
          },
          StandardSystemSearchParameter: {
            ...standardSystemState.StandardSystemSearchParameter,
            StandardSystemSearchParams: {
              ...standardSystemState.StandardSystemSearchParameter
                .StandardSystemSearchParams,
              StandardId: parameter.StandardId,
              Name: standardSystemPageState.StandardSystemSearchParameter
                .StandardSystemSearchParams.Name,
            },
          },
          Data: {} as PaginationDTO,
        })
      );
      dispatch(
        getStandardSystemList({
          ...standardSystemPageState.StandardSystemSearchParameter,
          StandardSystemSearchParams: {
            ...standardSystemPageState.StandardSystemSearchParameter
              .StandardSystemSearchParams,
            StandardId: parameter.StandardId,
          },
        })
      );

      setstandardSystemPageState((values) => {
        return {
          ...values,
          StandaradSystem: {
            ...values.StandaradSystem,
            StandardId: parameter.StandardId,
          },
          StandardSystemSearchParameter: {
            ...values.StandardSystemSearchParameter,
            StandardSystemSearchParams: {
              ...values.StandardSystemSearchParameter
                .StandardSystemSearchParams,
              StandardId: parameter.StandardId,
            },
          },
        };
      });
    }
  }, []);

  //when reducer state change
  useEffect(() => {
    if (!dataFetchedRef.current) return;
    setstandardSystemPageState((values) => {
      return {
        ...values,
        Data: {
          ...values.Data,
          Data: standardSystemState.Data.Data,
          TotalRecordsCount: standardSystemState.Data.TotalRecordsCount,
          SelectedPage: standardSystemState.Data.SelectedPage,
        },
        StandaradSystem: {
          Id: standardSystemState.StandaradSystem.Id,
          Name: standardSystemState.StandaradSystem.Name,
          StandardId: parameter.StandardId,
          Version: standardSystemState.StandaradSystem.Version,
          Status: standardSystemState.StandaradSystem.Status,
        } as StandardSystemDTO,
        StandardSystemSearchParameter: {
          ...values.StandardSystemSearchParameter,
          SelectedPage: standardSystemState.Data.SelectedPage,
          SortByNavigation:
            standardSystemState.StandardSystemSearchParameter.SortByNavigation,
          GridPageSize:
            standardSystemState.StandardSystemSearchParameter.GridPageSize,
        },
        SystemModalOpen: standardSystemState.SystemModalOpen,
        PageMode: standardSystemState.PageMode,
      };
    });
  }, [standardSystemState]);

  //================================ Search ============================================================

  const onChangeSearchName = (event: ChangeEvent<HTMLInputElement>) => {
    setstandardSystemPageState((values) => {
      return {
        ...values,
        StandardSystemSearchParameter: {
          ...values.StandardSystemSearchParameter,
          StandardSystemSearchParams: {
            ...values.StandardSystemSearchParameter.StandardSystemSearchParams,
            Name: event.target.value,
          },
        },
      };
    });

    if (!event.target.value) {
      dispatch(
        getStandardSystemList({
          ...standardSystemPageState.StandardSystemSearchParameter,
          StandardSystemSearchParams: {
            ...standardSystemPageState.StandardSystemSearchParameter
              .StandardSystemSearchParams,
            Name: "",
          },
        })
      );
    }
  };

  const onChangeStandardSystemSearchParameter = (
    isAdvanceSearch: boolean,
    selectedPage: number,
    pageSize?: number
  ) => {
    dispatch(
      setStandardSystemSearchParameter({
        ...standardSystemPageState.StandardSystemSearchParameter,
        IsAdvanceSearch: isAdvanceSearch,
        SelectedPage: selectedPage,
        GridPageSize:
          pageSize ??
          standardSystemPageState.StandardSystemSearchParameter.GridPageSize,
      })
    );

    dispatch(
      getStandardSystemList({
        ...standardSystemPageState.StandardSystemSearchParameter,
        IsAdvanceSearch: isAdvanceSearch,
        SelectedPage: selectedPage,
        GridPageSize:
          pageSize ??
          standardSystemPageState.StandardSystemSearchParameter.GridPageSize,
      })
    );
  };

  const onKeyPressSearchName = (event: any) => {
    if (event.charCode === 13) {
      event.preventDefault();

      if (
        standardSystemPageState.StandardSystemSearchParameter
          .StandardSystemSearchParams.Name !==
        standardSystemState.StandardSystemSearchParameter
          .StandardSystemSearchParams.Name
      ) {
        onChangeStandardSystemSearchParameter(
          standardSystemPageState?.StandardSystemSearchParameter
            ?.IsAdvanceSearch,
          1 //Default select 1st page
        );
      }
    }
  };

  const serachBtnClick = (IsAdvanceSearch: boolean) => {
    onChangeStandardSystemSearchParameter(
      IsAdvanceSearch,
      1 //Default select 1st page
    );
  };

  const onPaginationCallBack = (newPage: number, pageSize: number) => {
    if (
      standardSystemPageState.StandardSystemSearchParameter.SelectedPage !==
        newPage ||
      standardSystemPageState.StandardSystemSearchParameter.GridPageSize !==
        pageSize
    ) {
      onChangeStandardSystemSearchParameter(
        standardSystemPageState?.StandardSystemSearchParameter?.IsAdvanceSearch,
        newPage,
        pageSize
      );
    }
  };

  const onSortByNavigationCallBack = (
    selectedSortByNavigation: SortDropDownDTO
  ) => {
    dispatch(
      setStandardSystemSearchParameter({
        ...standardSystemPageState.StandardSystemSearchParameter,
        StandardSystemSearchParams: {
          ...standardSystemPageState.StandardSystemSearchParameter
            .StandardSystemSearchParams,
        },
        SortByNavigation: selectedSortByNavigation,
        SelectedPage: 1,
      })
    );

    dispatch(
      getStandardSystemList({
        ...standardSystemPageState.StandardSystemSearchParameter,
        StandardSystemSearchParams: {
          ...standardSystemPageState.StandardSystemSearchParameter
            .StandardSystemSearchParams,
        },
        SortByNavigation: selectedSortByNavigation,
        SelectedPage: 1,
      })
    );
  };

  //================================ End Search ============================================================

  const OnSystemTextChange = (name: string, value: any) => {
    setstandardSystemPageState((values) => {
      return {
        ...values,
        StandaradSystem: {
          ...values.StandaradSystem,
          Name: value,
        },
      };
    });
  };

  const SaveSystem = (buttonModeType: EnumButtonModeType) => {
    if (IsPageValid()) {
      //hide validation message
      standardSystemPageState.Validator.hideMessages();

      dispatch(
        saveStandardSystem({
          ...standardSystemPageState,
          ButtonModeType: buttonModeType,
        })
      );
    }
  };

  const UpdateSystem = (buttonModeType: EnumButtonModeType) => {
    if (IsPageValid()) {
      dispatch(
        updateStandardSystem({
          ...standardSystemPageState,
          ButtonModeType: buttonModeType,
        })
      );
    }
  };

  const IsPageValid = (): boolean => {
    let isValid = standardSystemPageState.Validator.allValid();
    if (!isValid) {
      setstandardSystemPageState((values) => {
        return {
          ...values,
          ShowErrorMsg: !standardSystemPageState.ShowErrorMsg,
        };
      });

      //show validation message
      standardSystemPageState.Validator.showMessages();

      return isValid;
    } else {
      //hide validation message
      standardSystemPageState.Validator.hideMessages();
    }

    return isValid;
  };

  //================ Button functions ===================//
  const onClickCancelBtn = () => {
    //hide validation message
    standardSystemPageState.Validator.hideMessages();

    if (standardSystemPageState.PageMode.IsShowEditBtn) {
      dispatch(
        setStandardSystem({
          Id: 0,
          Name: "",
          StandardId: parameter?.StandardId,
          Version: 1,
          Status: EnumStatus.Published,
        } as StandardSystemDTO)
      );

      dispatch(setPageMode(EnumPageMode.Default));
      handleClose();
    } else if (standardSystemPageState.PageMode.IsShowSaveBtn) {
      if (
        standardSystemPageState.StandaradSystem.Name === null ||
        standardSystemPageState.StandaradSystem.Name.match(/^ *$/) !== null
      ) {
        dispatch(
          setStandardSystem({
            Id: 0,
            Name: "",
            StandardId: parameter?.StandardId,
            Version: 1,
            Status: EnumStatus.Published,
          } as StandardSystemDTO)
        );
        dispatch(setPageMode(EnumPageMode.Default));
        handleClose();
      } else {
        dispatch(
          openPopup({
            Open: true,
            BodyText: "Do you want to discard the changes?",
            HeaderText: "Confirmation",
            PopupType: EnumPopupType.YesNoConfirmation,
            YesBtnClick() {
              dispatch(
                setStandardSystem({
                  Id: 0,
                  Name: "",
                  StandardId: parameter?.StandardId,
                  Version: 1,
                  Status: EnumStatus.Published,
                } as StandardSystemDTO)
              );
              dispatch(setPageMode(EnumPageMode.Default));
              handleClose();
            },
          } as PopupProps)
        );
      }
    } else {
      //Check original data changed
      if (
        standardSystemPageState.StandaradSystem.Name !==
        standardSystemState.StandaradSystem.Name
      ) {
        dispatch(
          openPopup({
            Open: true,
            BodyText: "Do you want to discard the changes?",
            HeaderText: "Confirmation",
            PopupType: EnumPopupType.YesNoConfirmation,
            YesBtnClick() {
              setstandardSystemPageState((values) => {
                return {
                  ...values,
                  StandaradSystem: {
                    Id: standardSystemState.StandaradSystem.Id,
                    Name: standardSystemState.StandaradSystem.Name,
                    StandardId: parameter?.StandardId,
                    Version: 1,
                    Status: standardSystemState.StandaradSystem.Status,
                  } as StandardSystemDTO,
                };
              });
              dispatch(setPageMode(EnumPageMode.ViewMode));
            },
          } as PopupProps)
        );
      } else {
        dispatch(setPageMode(EnumPageMode.ViewMode));
      }
    }
  };

  const CloseButtonClick = () => {
    dispatch(
      setStandardSystem({
        Id: 0,
        Name: "",
        StandardId: parameter?.StandardId,
        Version: 1,
        Status: EnumStatus.Published,
      } as StandardSystemDTO)
    );
    dispatch(setPageMode(EnumPageMode.Default));
    handleClose();
  };

  const onClickDeleteBtn = () => {
    dispatch(
      openPopup({
        Open: true,
        BodyText: "Are you sure you want to deactivate?",
        HeaderText: "Confirmation",
        PopupType: EnumPopupType.YesNoConfirmation,
        YesBtnClick() {
          if (standardSystemPageState.StandaradSystem?.Id > 0) {
            dispatch(deleteStandardSystem(standardSystemPageState));
          }
          //show validation message
          standardSystemPageState.Validator.hideMessages();
        },
      } as PopupProps)
    );
  };

  const onClickViewBtn = () => {
    dispatch(setPageMode(EnumPageMode.ViewMode));
    handleOpen();
  };

  const onClickAddBtn = () => {
    handleOpen();
    dispatch(setPageMode(EnumPageMode.AddMode));
  };

  const onClickEditBtn = () => {
    dispatch(setPageMode(EnumPageMode.EditMode));
  };

  //================ End Button functions ===================//
  // modal popup
  const style = {
    position: "absolute",
    top: "30%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  //------------------------------------

  return (
    <>
      {/* <Grid container columns={12} className="global-header-wrap"> */}
      {/* <Grid item xs={12} className="">
          <h1>{props.PageTitle + "s"}</h1>
        </Grid> */}
      {/* </Grid> */}
      <div className="content-section-card top-main-padding">
        <Grid container>
          {/* Button bar */}
          <Grid container>
            <div className="flex--container width100-p top-main-border-inner global-subhead-btn-wrap">
              <div className="flex__item--inherit pr-10">
                <Button
                  aria-label="back"
                  className="sub-head-back-btn back"
                  onClick={() => {
                    navigate("/standard", {
                      state: {
                        StandardId: parameter?.StandardId,
                      } as StandardPageParametersType,
                    });
                  }}
                  title="Back to home page"
                >
                  {/* <ArrowLeft2 size="24" variant="Outline" /> */}
                  <ArrowBackIosNewOutlinedIcon className="" />
                  <span className="body-bold secondary-color">Back</span>
                </Button>{" "}
              </div>
              <div className="">
                <h1 className="page_title">{props.PageTitle + "s"}</h1>
              </div>
              <div className="flex__item search-bar--small ml-10 mr-10">
                <Paper
                  component="form"
                  sx={{
                    p: "2px 4px",
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <InputBase
                    value={
                      standardSystemPageState.StandardSystemSearchParameter
                        .StandardReferenceSearchParams?.Name
                    }
                    onChange={onChangeSearchName}
                    onKeyPress={onKeyPressSearchName}
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search by System"
                    inputProps={{ "aria-label": "System" }}
                    type="search"
                  />
                  <IconButton
                    onClick={() => {
                      serachBtnClick(false);
                    }}
                    type="button"
                    sx={{ p: "10px" }}
                    aria-label="search"
                    className="m-0"
                  >
                    <SearchNormal1
                      variant="Outline"
                      className="ico-secondary"
                      size={18}
                    />
                  </IconButton>
                  {/* <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                  <IconButton
                    onClick={() => {
                      serachBtnClick(true);
                    }}
                    color="primary"
                    sx={{ p: "10px" }}
                    aria-label="directions"
                  >
                    <Filter variant="Outline" className="ico-secondary" />
                  </IconButton> */}
                  {/* <IconButton
                    onClick={() => {
                      serachBtnClick(false);
                    }}
                    type="button"
                    sx={{ p: "10px" }}
                    aria-label="search"
                  >
                    <SearchIcon />
                  </IconButton>
                  <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                  <IconButton

                    onClick={() => {
                      serachBtnClick(true);
                    }}
                    color="primary"
                    sx={{ p: "10px" }}
                    aria-label="directions"
                  >
                    <FilterAltOutlinedIcon />
                  </IconButton> */}
                </Paper>
              </div>
              {checkSystemFunctionRight(
                EnumSystemFunctions.SystemPage_Add_New_System,
                EnumSystemFunctionTypes.ButtonAccess
              ) && (
                <Button
                  className="primary-btn-small"
                  size="small"
                  disableElevation
                  variant="outlined"
                  startIcon={<AddCircle variant="Outline" />}
                  onClick={onClickAddBtn}
                  style={{
                    visibility:
                      standardSystemPageState?.PageMode?.IsShowAddBtn &&
                      parameter?.StatusId !== EnumStatus.Deactivated
                        ? "visible"
                        : "hidden",
                  }}
                >
                  Add
                </Button>
              )}
            </div>
          </Grid>
          <Grid container>
            <Modal
              className="modal-outter sub-form-section"
              open={standardSystemPageState.SystemModalOpen}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <div className="modal-header">
                  <h1>
                    <span>System</span>
                    <span>
                      {standardSystemPageState.PageMode.IsShowSaveBtn ? (
                        <>
                          <HPRSplitButton
                            Name="SystemSave"
                            ButtonOptions={[
                              {
                                ButtonId: "0",
                                ButtonName: "Save",
                                onButtonClickCallBack: () => {
                                  SaveSystem(EnumButtonModeType.Save);
                                },
                              },
                              {
                                ButtonId: "1",
                                ButtonName: "Save & Close",
                                onButtonClickCallBack: () => {
                                  SaveSystem(EnumButtonModeType.SaveAndClose);
                                },
                              },
                              {
                                ButtonId: "2",
                                ButtonName: "Save & Continue",
                                onButtonClickCallBack: () => {
                                  SaveSystem(
                                    EnumButtonModeType.SaveAndContinue
                                  );
                                },
                              },
                            ]}
                          ></HPRSplitButton>
                        </>
                      ) : (
                        <></>
                      )}
                      {standardSystemPageState.PageMode.IsShowUpdateBtn ? (
                        <>
                          <HPRSplitButton
                            Name="SystemUpdateBtn"
                            ButtonOptions={[
                              {
                                ButtonId: "0",
                                ButtonName: "Update & Close",
                                onButtonClickCallBack: () => {
                                  UpdateSystem(
                                    EnumButtonModeType.UpdateAndClose
                                  );
                                },
                              },
                              {
                                ButtonId: "1",
                                ButtonName: "Update",
                                onButtonClickCallBack: () => {
                                  UpdateSystem(EnumButtonModeType.Update);
                                },
                              },
                            ]}
                          ></HPRSplitButton>
                        </>
                      ) : (
                        <></>
                      )}
                      {standardSystemPageState.PageMode.IsShowEditBtn &&
                      checkSystemFunctionRight(
                        EnumSystemFunctions.SystemPage_Edit_System,
                        EnumSystemFunctionTypes.ButtonAccess
                      ) ? (
                        <>
                          <Button
                            className="primary-btn-small"
                            size="small"
                            variant="outlined"
                            disableElevation
                            onClick={onClickEditBtn}
                            startIcon={<Edit variant="Outline" />}
                          >
                            Edit
                          </Button>
                        </>
                      ) : (
                        <></>
                      )}
                      {standardSystemPageState.PageMode.IsShowDeleteBtn &&
                      checkSystemFunctionRight(
                        EnumSystemFunctions.SystemPage_Deactivate_System,
                        EnumSystemFunctionTypes.ButtonAccess
                      ) ? (
                        <>
                          <Button
                            className="primary-btn-small"
                            size="small"
                            variant="outlined"
                            disableElevation
                            startIcon={<CardSlash variant="Outline" />}
                            onClick={onClickDeleteBtn}
                          >
                            Deactivate
                          </Button>
                        </>
                      ) : (
                        <></>
                      )}
                      {standardSystemPageState.PageMode.IsShowCancelBtn ? (
                        <>
                          {" "}
                          <Button
                            className="secondary-btn-small"
                            size="small"
                            variant="outlined"
                            disableElevation
                            startIcon={<CloseCircle variant="Outline" />}
                            onClick={onClickCancelBtn}
                          >
                            Cancel
                          </Button>
                        </>
                      ) : (
                        <></>
                      )}
                      {standardSystemPageState.PageMode.IsShowCloseBtn && (
                        <Button
                          className="secondary-btn-small"
                          size="small"
                          variant="outlined"
                          disableElevation
                          onClick={CloseButtonClick}
                          startIcon={<CloseCircle variant="Outline" />}
                        >
                          Close
                        </Button>
                      )}
                    </span>
                  </h1>
                </div>
                <div className="modal-content">
                  <Grid container columns={12}>
                    <Grid
                      item
                      xl={9}
                      lg={6}
                      md={8}
                      sm={12}
                      xs={12}
                      className="m-auto"
                    >
                      <div className="form-group">
                        <HPRTextBox
                          Label="System"
                          Name="system"
                          Value={standardSystemPageState?.StandaradSystem.Name}
                          Type={EnumTextBoxType.Text}
                          Disabled={standardSystemPageState.PageMode.IsDisable}
                          onTextBoxChange={OnSystemTextChange}
                          Validator={standardSystemPageState.Validator}
                          Rules={"required"}
                          IsEnableValidator={true}
                          AutoFocus={
                            !standardSystemPageState.PageMode.IsDisable
                          }
                          Required={true}
                          InputProps={{ maxLength: 250 }}
                        ></HPRTextBox>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Box>
            </Modal>

            <div className="HPRDataGrid-wrapper content-inner-wrap pl-10 pr-10">
              <HPRDataGrid
                Columns={columns}
                Data={standardSystemPageState?.Data?.Data}
                TotalRecordsCount={
                  standardSystemPageState?.Data?.TotalRecordsCount
                }
                AutoHeight={true}
                onPaginationChangeCallBack={onPaginationCallBack}
                SelectedPage={standardSystemPageState.Data?.SelectedPage ?? 0}
                HPRDataGridToolbarProps={
                  {
                    ShowTotalRecordsCount: true,
                  } as HPRDataGridToolbarProps
                }
                PageSize={
                  standardSystemPageState?.StandardSystemSearchParameter
                    ?.GridPageSize ??
                  EnumGridDataShowRowCount.GridDataShowRowCount_2
                }
                // MenuFunctions={{
                //   onChangeSortByNavigation: onSortByNavigationCallBack,

                // }}
                ShowCustomePagination
              ></HPRDataGrid>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default SystemPage;
